import React from "react"

import globalStyles from "../../../../App.module.scss";
import average from './images/average.png'
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

export default function Average() {

    let data =`# Handle user input
def get_numbers() -> list[float]:
    numbers = []
    while True:
        user_input = input("Enter a number: ")
        try:
            numbers.append(float(user_input))
        except ValueError:
            # Stop collecting when user enters invalid or empty
            break
    return numbers


# Do the calculation
def get_avg(numbers: list[float]) -> tuple[int, float]:
    n_count = len(numbers)
    n_avg = round(sum(numbers) / n_count, 2) if n_count > 0 else 0
    return n_count, n_avg


def main():
    numbers = get_numbers()
    # Handle no input case
    if not numbers:
        print("No numbers entered.")
        return

    count, average = get_avg(numbers)
    print("Highest: ", max(numbers), "Lowest: ", min(numbers))
    print("Total numbers: ", count, "Average: ", average)
    print("Input: ", numbers)


if __name__ == "__main__":
    main()
`

    return (
        <div className={globalStyles.article}>
            <h1>Average number calculator</h1>
            <p>This program ask the user for numbers until invalid number is entered. Afterwards calculates the average, total,
                maximum and minimum numbers entered</p>
            <div style={{ maxWidth: '800px'}}>
                <SyntaxHighlighter
                    children={data}
                    style={dracula}
                    PreTag="div"
                    language={'bash'}
                />
            </div>
            <p>The program above produces the next output:</p>
            <div style={{maxHeight: '151px', maxWidth: '515px'}}>
                <img src={average} alt={""}/>
            </div>

        </div>
    )
}
